import React, { Component } from 'react';
import FormControl from '@mui/material/FormControl';
import i18n from '../../../i18n';
import MultipleSelect from './MultipleSelect';
import SingleSelect from './SingleSelect';
import PropTypes from 'prop-types';

class FilterItemsField extends Component {
    field;
    constructor(props) {
        super(props);
        this.state = {
            items: [],
            selectedItems: []
        };
        this.field = props.field;
    }

    componentDidMount() {
        let selectedItems = this.props.param ? [this.props.param] : [];
        if (this.props.filters) {
            const filterByKey = this.field.filterBy;
            const match = this.props.filters
                .flat()
                ?.find((f) => f.field === filterByKey);
            if (match?.value?.length) {
                selectedItems = this.field.multiple
                    ? match.value
                    : [match.value[0]];
            }
        }
        this.setState({
            items: this.field.items,
            selectedItems
        });
    }

    handleChange(value) {
        this.setState({
            selectedItems: value
        });
        this.props.handleFilter(this.field.id, value);
    }

    render() {
        const translatedLabel = i18n.t('text.filterBy', {
            field: i18n.t(`columns.${this.field.label}`)
        });
        return (
            <FormControl sx={{ width: '100%', maxWidth: this.props.maxWidth || '350px', m: 1, flex: '1 1 0', minWidth: '100px' }}>
                {this.field.multiple ? (
                    <MultipleSelect
                        label={translatedLabel}
                        items={this.state.items}
                        selectedItems={this.state.selectedItems}
                        handleChange={(value) => this.handleChange(value)}
                        trKey={this.field.translate}
                        helperText={this.props.helperText}
                        disabled={this.props.disabled}
                    />
                ) : (
                    <SingleSelect
                        label={translatedLabel}
                        items={this.state.items}
                        selectedItem={
                            this.state.selectedItems.length
                                ? this.state.selectedItems.at(0)
                                : ''
                        }
                        trKey={this.field.translate}
                        handleChange={(value) => this.handleChange(value)}
                        helperText={this.props.helperText}
                        disabled={this.props.disabled}
                    />
                )}
            </FormControl>
        );
    }
}

export default FilterItemsField;

FilterItemsField.propTypes = {
    field: PropTypes.shape({
        id: PropTypes.string.isRequired,
        items: PropTypes.array.isRequired,
        label: PropTypes.string.isRequired,
        multiple: PropTypes.bool,
        translate: PropTypes.string
    }).isRequired,
    handleFilter: PropTypes.func.isRequired
};

FilterItemsField.defaultProps = {
    field: {
        multiple: false
    }
};
